import { createContext } from 'use-context-selector';
const TopbarActionsContext = createContext(() => () => null);
export default TopbarActionsContext;
